import React, { useMemo } from 'react';
import { ValuationComparing } from '../../interfaces/valuation';
import dayjs from 'dayjs';
import { Tag } from 'antd';
import useSWR from 'swr';
import { ValuationApi } from '../../apis';
import { formatCurrency } from '../../utils';

const LoanOfficerSideCard = ({ payload: _payload }: { payload: ValuationComparing }) => {
  const { data: payload } = useSWR(
    'swr.valuation.payload',
    async () => await ValuationApi.get(_payload.id!)
  );

  const status = useMemo(() => {
    switch (payload.status) {
      case 'PENDING':
        return <Tag color="yellow">Хүлээгдэж буй</Tag>;
      case 'RETURNED':
        return <Tag color="blue">Буцаасан</Tag>;
      case 'REJECTED':
        return <Tag color="red">Татгалзсан</Tag>;
      case 'VALUATED':
        return <Tag color="green">Үнэлсэн</Tag>;
      case 'DRAFT':
        return <Tag color="gray">Ноорог</Tag>;
      default:
    }
  }, [payload.status]);

  return (
    <div className="top-[443px] rounded-[14px] border border-[#F1F5F9] opacity-100 p-[20px]">
      <div className="font-manrope font-semibold text-[20px] leading-[32px] tracking-[-0.02em]">
        Нэмэлт мэдээлэл
      </div>
      <div className="h-[20px]" />
      <div className="flex flex-col gap-[10px]">
        <div className=" h-[81px] opacity-100 border-b border-[#F1F5F9] flex flex-1 flex-row pb-[17px] pl-[17px]">
          <div className="flex flex-1 flex-col">
            <div className="font-manrope font-normal text-[14px] leading-[20px] tracking-[-0.28px] text-[#6A6A6A]">
              Зээл хүсэгчийн овог, нэр
            </div>
            <div className=" font-manrope font-medium text-[16px] leading-[24px] tracking-[-0.48px] text-[#282830]">
              {payload?.customer?.fullName}
            </div>
          </div>
          <div className="flex flex-1 flex-col">
            <div className="font-manrope font-normal text-[14px] leading-[20px] tracking-[-0.28px] text-[#6A6A6A]">
              Регистрийн дугаар
            </div>
            <div className=" font-manrope font-medium text-[16px] leading-[24px] tracking-[-0.48px] text-[#282830]">
              {payload?.customer?.registerNo}
            </div>
          </div>
        </div>
        {/* item 2 */}

        <div className=" h-[81px] opacity-100 border-b border-[#F1F5F9] flex flex-1 flex-row pb-[17px] pl-[17px]">
          <div className="flex flex-1 flex-col">
            <div className="font-manrope font-normal text-[14px] leading-[20px] tracking-[-0.28px] text-[#6A6A6A]">
              Зээлийн мэргэжилтэн
            </div>
            <div className=" font-manrope font-medium text-[16px] leading-[24px] tracking-[-0.48px] text-[#282830]">
              {payload?.valuationUser?.fullName}
            </div>
          </div>
          <div className="flex flex-1 flex-col">
            <div className="font-manrope font-normal text-[14px] leading-[20px] tracking-[-0.28px] text-[#6A6A6A]">
              Хүсэлтийн огноо
            </div>
            <div className=" font-manrope font-medium text-[16px] leading-[24px] tracking-[-0.48px] text-[#282830]">
              {dayjs(payload.createdAt).format('YYYY-MM-DD')}
            </div>
          </div>
        </div>

        {/* item 3 */}

        <div className=" h-[81px] opacity-100 border-b border-[#F1F5F9] flex flex-1 flex-row pb-[17px] pl-[17px]">
          <div className="flex flex-1 flex-col">
            <div className="font-manrope font-normal text-[14px] leading-[20px] tracking-[-0.28px] text-[#6A6A6A]">
              Үнэлгээний дугаар
            </div>
            <div className=" font-manrope font-medium text-[16px] leading-[24px] tracking-[-0.48px] text-[#282830]">
              {payload.sequence}
            </div>
          </div>
          <div className="flex flex-1 flex-col">
            <div className="font-manrope font-normal text-[14px] leading-[20px] tracking-[-0.28px] text-[#6A6A6A]">
              Километрийн заалтаас хамаарсан зохицуулалт
            </div>
            <div className=" font-manrope font-medium text-[16px] leading-[24px] tracking-[-0.48px] text-[#282830]">
              {payload.percentOdo}%
            </div>
          </div>
        </div>



        <div className=" h-[81px] opacity-100 border-b border-[#F1F5F9] flex flex-1 flex-row pb-[17px] pl-[17px]">
          <div className="flex flex-1 flex-col">
            <div className="font-manrope font-normal text-[14px] leading-[20px] tracking-[-0.28px] text-[#6A6A6A]">
              Зохицуулагдсан үнэлгээ
            </div>
            <div className=" font-manrope font-medium text-[16px] leading-[24px] tracking-[-0.48px] text-[#282830]">
              {formatCurrency(payload.price) || 0}
            </div>
          </div>
          <div className="flex flex-1 flex-col">
            <div className="font-manrope font-normal text-[14px] leading-[20px] tracking-[-0.28px] text-[#6A6A6A]">
              Эцэлсэн үнэлгээ
            </div>
            <div className=" font-manrope font-medium text-[16px] leading-[24px] tracking-[-0.48px] text-[#282830]">
              {formatCurrency(payload.priceFinal) || 0}
            </div>
          </div>
        </div>



        <div className="w-[454px] h-[81px] opacity-100  flex flex-1 flex-row pb-[17px] pl-[17px] pr-[17px]">
          <div className="flex flex-1 flex-col">
            <div className="flex flex-row justify-between items-center">
              <div className="font-manrope font-normal text-[14px] leading-[20px] tracking-[-0.28px] text-[#6A6A6A]">
                Салбарын удирдлагын зохицуулалт
              </div>

              {/* <div className="">{status}</div> */}
            </div>
            <div className="h-[7px]" />
            <div className=" font-manrope font-medium text-[16px] leading-[24px] tracking-[-0.48px] text-[#282830]">
              <div className="flex flex-row gap-[10px]">
                <div className=" font-manrope font-medium text-[16px] leading-[24px] tracking-[-0.48px] text-[#282830]">
                  {payload.percentBranchHead}%
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* end */}
      </div>
    </div>
  );
};

export { LoanOfficerSideCard };
